<script lang="ts" setup>
const { t } = useI18n()
const guards = useGuards()
const { showCompanyProfile } = useCompany()
const { createToast } = useToasts()

const trophies: BaseTrophy[] = [
  {
    domain: 'paloaltonetworks.com',
    height: 11,
    name: 'palo-alto-networks',
  },
  {
    domain: 'crisp.chat',
    height: 8.5,
    name: 'crisp',
  },
  {
    domain: 'x.ai',
    height: 11,
    name: 'grok',
  },
  {
    domain: 'trustedsite.com',
    height: 11,
    name: 'trustedsite',
  },
]

async function onTrophyClick(domain: string) {
  await guards.awaitUser({
    onClose: () => {
      createToast({
        message: 'loginRequired',
        status: 'warning',
      })
    },
    onSuccess: () => {
      showCompanyProfile(domain)
    },
  })
}
</script>

<template>
  <div class="mx-auto flex max-w-4xl select-none flex-col items-center justify-center gap-6 text-center sm:gap-8">
    <h3 class="text-sm font-semibold uppercase tracking-tight">
      {{ t('title') }}
    </h3>

    <div class="grid w-full grid-cols-2 gap-8 sm:grid-cols-4">
      <BaseTrophy
        v-for="trophy in trophies"
        :key="trophy.domain"
        class="cursor-pointer"
        :domain="trophy.domain"
        :height="trophy.height"
        :hidden-on-mobile="trophy.hiddenOnMobile"
        :hidden-on-tablet="trophy.hiddenOnTablet"
        :hidden-on-xs-mobile="trophy.hiddenOnXsMobile"
        :name="trophy.name"
        @click="onTrophyClick(trophy.domain)"
      />
    </div>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "title": "Join 1,000+ companies from all sizes using our data"
  },
  "es": {
    "title": "Únete a 1,000+ empresas de todos los tamaños que utilizan nuestros datos"
  },
  "fr": {
    "title": "Rejoignez 1,000+ entreprises de toutes tailles qui utilisent nos données"
  }
}
</i18n>
